import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { PageCSSVars, PageDefinition } from '@wix/thunderbolt-becky-types'

const isNumeric = (val: string): boolean => {
	return !isNaN(Number(val))
}

// Remove Partial
export const css = withCompInfo<Partial<PageCSSVars>, PageDefinition>()(
	['styleProperties', 'hasResponsiveLayout', 'compProps', 'isMobileView', 'siteColors'],
	({ styleProperties, hasResponsiveLayout, compProps, isMobileView, siteColors }) => {
		const pageMinHeightDefault = isMobileView ? 200 : 500
		const deviceCompProp = isMobileView ? compProps.mobile : compProps.desktop

		const minHeight = (deviceCompProp && deviceCompProp.minHeight) || pageMinHeightDefault
		const minHeightValue = isNumeric(minHeight) ? `${minHeight}px` : minHeight

		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})

		const classicStyles = hasResponsiveLayout ? {} : { width: 'auto', 'min-height': minHeightValue }
		return {
			...brightnessParams,
			...classicStyles,
		}
	}
)
